import { useState, useEffect } from "react";
import { useTheme } from "../components/Theme";
import { getPerfil } from "../components/Permissoes";
import api from "../api";
import { Clock, AlertTriangle, CheckCircle2, Plus, ListChecks, Flag } from "lucide-react";

const TIPOS = [
  { id:"tarefa",label:"Tarefa" },{ id:"ligacao",label:"Ligação" },
  { id:"reuniao",label:"Reunião" },{ id:"email",label:"Email" },{ id:"whatsapp",label:"WhatsApp" },{ id:"marco",label:"Marco" },
];
const PRIOS = { alta:{label:"alta",cor:"#E24B4A"}, media:{label:"média",cor:"#EBA13A"}, baixa:{label:"baixa",cor:"#1D9E75"} };
const PRIO_BADGE = { alta:{label:"Alta",cor:"#E24B4A"}, media:{label:"Média",cor:"#8A5A12"}, baixa:{label:"Baixa",cor:"#0A7A4A"} };
const STATUS = {
  pendente:  { label:"Pendente",     cor:"#98A2B3" },
  andamento: { label:"Em andamento", cor:"#579bfc" },
  pausada:   { label:"Pausada",      cor:"#EBA13A" },
  concluida: { label:"Concluída",    cor:"#1D9E75" },
};

function ymd(d){ if(!d) return null; const s=String(d); const m=s.match(/^(\d{4})-(\d{2})-(\d{2})/); if(m) return {a:+m[1],me:+m[2],di:+m[3]}; const dt=new Date(d); return {a:dt.getFullYear(),me:dt.getMonth()+1,di:dt.getDate()}; }
function fmtBRcru(d){ const p=ymd(d); if(!p) return "—"; return String(p.di).padStart(2,"0")+"/"+String(p.me).padStart(2,"0")+"/"+p.a; }
function fmtData(d){ if(!d) return ""; const dt=new Date(d); const h=new Date();h.setHours(0,0,0,0); const a=new Date(dt);a.setHours(0,0,0,0); const diff=Math.round((a-h)/86400000); if(diff===0)return"hoje"; if(diff===1)return"amanhã"; if(diff===-1)return"ontem"; return fmtBRcru(d); }
function estaAtrasada(atv){ if(atv.concluida||atv.status==="concluida"||!atv.prazo) return false; const p=ymd(atv.prazo); if(!p) return false; const h=new Date(); const hoje=new Date(h.getFullYear(),h.getMonth(),h.getDate()); const alvo=new Date(p.a,p.me-1,p.di); return alvo<hoje; }
function calcDuracao(ini,fim){ if(!ini||!fim) return "—"; const d=Math.round((new Date(fim)-new Date(ini))/86400000); if(d<0) return "—"; if(d===0) return "1 dia"; return d+" dias"; }
function progressoTempo(ini,fim){
  if(!ini||!fim) return null;
  const pi=ymd(ini), pf=ymd(fim); if(!pi||!pf) return null;
  const di=new Date(pi.a,pi.me-1,pi.di).getTime();
  const df=new Date(pf.a,pf.me-1,pf.di).getTime();
  const h=new Date(); const hoje=new Date(h.getFullYear(),h.getMonth(),h.getDate()).getTime();
  if(df<=di) return hoje>=df?100:0;
  if(hoje<=di) return 0;
  if(hoje>=df) return 100;
  return Math.round(((hoje-di)/(df-di))*100);
}
function toInput(d){ const p=ymd(d); if(!p) return ""; return p.a+"-"+String(p.me).padStart(2,"0")+"-"+String(p.di).padStart(2,"0"); }

export default function Atividades({ currentUser }) {
  const { theme } = useTheme();
  const isAdmin = ["admin","gerente"].includes(currentUser?.role);

  const [lista, setLista] = useState([]);
  const [load, setLoad]   = useState(true);
  const [filtro, setFiltro] = useState("todas");
  const [filtroPrio, setFiltroPrio] = useState(null);
  const [view, setView] = useState("cards");
  const [users, setUsers] = useState([]);
  const [modal, setModal] = useState(null);

  const carregar = async () => {
    try { const { data } = await api.get("/atividades"); setLista(data); }
    catch (e) { console.error(e); } finally { setLoad(false); }
  };
  useEffect(() => { carregar(); }, []);
  useEffect(() => { api.get("/users").then(({data})=>setUsers(data)).catch(()=>{}); }, []);

  const salvar = async (form) => {
    const resps = Array.isArray(form.responsaveis) ? form.responsaveis.filter(Boolean) : (form.responsavelNome?[form.responsavelNome]:[]);
    const body = { ...form, prazo:form.prazo||null, dataInicio:form.dataInicio||null, dataConclusao:form.dataConclusao||null, progresso:Number(form.progresso)||0, responsaveis:resps, responsavelNome:resps[0]||"" };
    if (body.status==="concluida") body.concluida = true;
    if (body.status && body.status!=="concluida") body.concluida = false;
    try {
      if (form._id) {
        const { data } = await api.patch(`/atividades/${form._id}`, body);
        setLista(prev => prev.map(a => a._id===form._id ? data : a));
      } else {
        const { data } = await api.post("/atividades", body);
        setLista(prev => [data, ...prev]);
      }
      setModal(null);
    } catch (e) { console.error(e); }
  };
  const toggle = async (atv) => {
    const novo = !(atv.status==="concluida"||atv.concluida);
    try { const { data } = await api.patch(`/atividades/${atv._id}`, { concluida:novo, status:novo?"concluida":"pendente", progresso:novo?100:atv.progresso }); setLista(prev => prev.map(a => a._id===atv._id ? data : a)); }
    catch (e) { console.error(e); }
  };
  const remover = async (atv) => { try { await api.delete(`/atividades/${atv._id}`); setLista(prev => prev.filter(a => a._id!==atv._id)); } catch (e) { console.error(e); } };

  const hoje0 = new Date(); hoje0.setHours(0,0,0,0);
  const ehHoje = (d)=>{ const p=ymd(d); if(!p) return false; const h=new Date(); return p.a===h.getFullYear() && p.me===(h.getMonth()+1) && p.di===h.getDate(); };
  const isConcl = (a)=> a.concluida || a.status==="concluida";
  const pendentes = lista.filter(a => { if(isConcl(a)) return false; if(filtro==="hoje")return ehHoje(a.prazo); if(filtro==="atrasada")return estaAtrasada(a); if(filtro==="semprazo")return !a.prazo; return true; });
  const concluidas = lista.filter(isConcl);
  const atrasadas = lista.filter(a => estaAtrasada(a));
  const deHoje = lista.filter(a => !isConcl(a) && ehHoje(a.prazo));
  const futuras = lista.filter(a => { if(isConcl(a)||!a.prazo) return false; const x=new Date(a.prazo);x.setHours(0,0,0,0); return x>hoje0; });
  const semPrazo = lista.filter(a => !isConcl(a) && !a.prazo);
  const seuDia = [...atrasadas, ...deHoje];
  const concluidasHoje = lista.filter(a => isConcl(a) && a.concluidaEm && ehHoje(a.concluidaEm));
  const listaTabela = lista.filter(a => {
    if (isConcl(a)) return false;
    if (filtroPrio && a.prioridade!==filtroPrio) return false;
    if (filtro==="hoje")     return ehHoje(a.prazo);
    if (filtro==="atrasada") return estaAtrasada(a);
    if (filtro==="semprazo") return !a.prazo;
    return true;
  });
  const listaConcluidas = lista.filter(isConcl);
  const tabProps = {
    onEditar:(atv)=>setModal({ ...atv, prazo:toInput(atv.prazo), dataInicio:toInput(atv.dataInicio), dataConclusao:toInput(atv.dataConclusao), responsaveis:(atv.responsaveis&&atv.responsaveis.length)?atv.responsaveis:(atv.responsavelNome?[atv.responsavelNome]:[]) }),
    onExcluir:remover,
    onSalvarCampo:async (id,campo,valor)=>{ try { let payload; if(campo==="__status__"){ payload = valor==="concluida" ? { status:"concluida", concluida:true, progresso:100 } : { status:valor, concluida:false }; } else { payload = { [campo]:valor }; } const { data } = await api.patch(`/atividades/${id}`, payload); setLista(prev=>prev.map(a=>a._id===id?data:a)); } catch(e){ console.error(e); } },
  };

  const Item = ({ atv }) => {
    const p = PRIOS[atv.prioridade]||PRIOS.media;
    const t = TIPOS.find(x=>x.id===atv.tipo);
    const st = STATUS[atv.status]||STATUS.pendente;
    const atras = estaAtrasada(atv);
    const concl = isConcl(atv);
    const corBorda = atras ? "#E24B4A" : p.cor;
    return (
      <div style={{ display:"flex", alignItems:"center", gap:11, border:"1px solid var(--border-color)", borderLeft:concl?"1px solid var(--border-color)":`3px solid ${corBorda}`, borderRadius:8, padding:"13px 15px", marginBottom:9, background:"var(--card-bg)", opacity:concl?.6:1 }}>
        <button onClick={()=>toggle(atv)} title={concl?"Reabrir":"Concluir"}
          style={{ width:18, height:18, borderRadius:5, flexShrink:0, cursor:"pointer", border:concl?"none":"1.5px solid var(--border-color)", background:concl?"#1D9E75":"transparent", color:"#fff", fontSize:12, display:"flex", alignItems:"center", justifyContent:"center" }}>{concl?"✓":""}</button>
        <div style={{ flex:1, minWidth:0, cursor:"pointer" }} onClick={()=>setModal({ ...atv, prazo:toInput(atv.prazo), dataInicio:toInput(atv.dataInicio), dataConclusao:toInput(atv.dataConclusao), responsaveis:(atv.responsaveis&&atv.responsaveis.length)?atv.responsaveis:(atv.responsavelNome?[atv.responsavelNome]:[]) })}>
          <div style={{ display:"flex", alignItems:"center", gap:8 }}>
            {!concl && <span title={`prioridade ${p.label}`} style={{ width:8, height:8, borderRadius:"50%", background:p.cor, flexShrink:0 }}/>}
            <span style={{ fontWeight:500, fontSize:13.5, color:"var(--text-primary)", textDecoration:concl?"line-through":"none", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{atv.titulo}</span>
          </div>
          <div style={{ fontSize:11, color:"var(--text-muted)", marginTop:6, display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}>
            <span style={{ background:st.cor+"1f", color:st.cor, padding:"1px 8px", borderRadius:99, fontSize:10, fontWeight:600 }}>{st.label}</span>
            <span style={{ background:"var(--input-bg)", border:"1px solid var(--border-color)", padding:"1px 8px", borderRadius:99, fontSize:10 }}>{t?.label}</span>
            {atras ? <span style={{ color:"#E24B4A", fontWeight:600 }}>{atv.prazo?fmtData(atv.prazo):""} · atrasada</span>
                   : (atv.prazo && !concl && <span>{fmtData(atv.prazo)}</span>)}
            {Number(atv.progresso)>0 && !concl && (
              <span style={{ display:"inline-flex", alignItems:"center", gap:5 }}>
                <span style={{ width:44, height:5, borderRadius:99, background:"var(--input-bg)", overflow:"hidden", display:"inline-block" }}>
                  <span style={{ display:"block", height:"100%", width:`${atv.progresso}%`, background:st.cor }}/>
                </span>{atv.progresso}%
              </span>
            )}
          </div>
        </div>
        {isAdmin && (atv.responsavelNome||atv.nomeUsuario) && <span style={{ fontSize:11, color:"var(--text-secondary)", flexShrink:0 }}>{atv.responsavelNome||atv.nomeUsuario}</span>}
        <button onClick={()=>remover(atv)} title="Remover" style={{ background:"none", border:"none", color:"var(--text-muted)", cursor:"pointer", fontSize:15, flexShrink:0, padding:"2px 6px" }}>×</button>
      </div>
    );
  };

  const Sec = ({ titulo, n }) => <div style={{ fontSize:11, fontWeight:600, color:"var(--text-secondary)", textTransform:"uppercase", letterSpacing:".05em", margin:"26px 0 10px" }}>{titulo} · {n}</div>;

  return (
    <div style={{ padding:"8px 32px 48px" }}>
      <div style={{ display:"flex", alignItems:"center", gap:8, padding:"14px 0 16px", borderBottom:"1px solid var(--border-color)", marginBottom:16 }}>
        <div style={{ display:"flex", gap:6, flex:1 }}>
          {[["todas","Todas"],["hoje","Hoje"],["atrasada","Atrasadas"],["semprazo","Sem prazo"]].map(([id,lbl])=>(
            <button key={id} onClick={()=>setFiltro(id)} style={{ padding:"6px 14px", borderRadius:8, fontSize:12.5, fontWeight:filtro===id?600:400, cursor:"pointer", border:"1px solid var(--border-color)", background:filtro===id?"#EE6A1A":"transparent", color:filtro===id?"var(--card-bg)":"var(--text-secondary)" }}>{lbl}</button>
          ))}
        </div>
        <button onClick={()=>setModal({ tipo:"tarefa", prioridade:"media", status:"pendente", progresso:0 })}
          style={{ display:"flex", alignItems:"center", gap:6, background:"#EE6A1A", border:"none", borderRadius:8, padding:"9px 16px", color:"#fff", fontWeight:600, fontSize:13, cursor:"pointer" }}><Plus size={16}/> Nova atividade</button>
      </div>

      {load ? <div style={{ color:"var(--text-muted)", fontSize:13, padding:"20px 0" }}>Carregando...</div> : (
        <>
          <div style={{ display:"flex", gap:10, marginBottom:22 }}>
            {[["todas",lista.length,"#585858",ListChecks],["para hoje",deHoje.length,"#EE6A1A",Clock],["atrasadas",atrasadas.length,"#E24B4A",AlertTriangle],["concluídas",concluidas.length,"#1D9E75",CheckCircle2]].map(([lbl,val,cor,Ico])=>(
              <div key={lbl} style={{ flex:1, background:cor+"14", border:`1px solid ${cor}33`, borderRadius:10, padding:"14px 16px", position:"relative", overflow:"hidden" }}>
                <Ico size={34} color={cor} style={{ position:"absolute", top:12, right:12, opacity:.18 }}/>
                <div style={{ fontSize:26, fontWeight:800, color:cor, lineHeight:1, letterSpacing:"-.02em" }}>{val}</div>
                <div style={{ fontSize:11, color:"var(--text-muted)", marginTop:6, textTransform:"uppercase", letterSpacing:".04em", fontWeight:600 }}>{lbl}</div>
              </div>
            ))}
          </div>
          <div style={{ display:"flex", gap:10, marginBottom:22 }}>
            {[["prioridade alta","alta",lista.filter(a=>!isConcl(a)&&a.prioridade==="alta").length,"#E24B4A"],["prioridade média","media",lista.filter(a=>!isConcl(a)&&a.prioridade==="media").length,"#EBA13A"],["prioridade baixa","baixa",lista.filter(a=>!isConcl(a)&&a.prioridade==="baixa").length,"#1D9E75"]].map(([lbl,prio,val,cor])=>{
              const ativo = filtroPrio===prio;
              return (
              <div key={lbl} onClick={()=>setFiltroPrio(ativo?null:prio)} style={{ flex:1, background:cor+(ativo?"26":"14"), border:`${ativo?2:1}px solid ${cor}${ativo?"":"33"}`, borderRadius:10, padding:"14px 16px", position:"relative", overflow:"hidden", cursor:"pointer" }}>
                <Flag size={34} color={cor} style={{ position:"absolute", top:12, right:12, opacity:.18 }}/>
                <div style={{ fontSize:26, fontWeight:800, color:cor, lineHeight:1, letterSpacing:"-.02em" }}>{val}</div>
                <div style={{ fontSize:11, color:"var(--text-muted)", marginTop:6, textTransform:"uppercase", letterSpacing:".04em", fontWeight:600 }}>{lbl}{ativo?" ✓":""}</div>
              </div>
              );
            })}
          </div>
          <TabelaCronograma lista={listaTabela} {...tabProps}/>
          {listaConcluidas.length>0 && (
            <div style={{ marginTop:28 }}>
              <div style={{ fontSize:12, fontWeight:700, color:"#1D9E75", textTransform:"uppercase", letterSpacing:".05em", marginBottom:10, display:"flex", alignItems:"center", gap:6 }}>✓ Concluídos · {listaConcluidas.length}</div>
              <TabelaCronograma lista={listaConcluidas} {...tabProps}/>
            </div>
          )}
        </>
      )}

      {modal && <ModalAtividade dados={modal} users={users} currentUser={currentUser} onClose={()=>setModal(null)} onSalvar={salvar} onAtualizar={(nova)=>{ setLista(prev=>prev.map(a=>a._id===nova._id?nova:a)); setModal(m=>m&&m._id===nova._id?{...m, comentarios:nova.comentarios}:m); }}/>}
    </div>
  );
}

const CORES_RESP = [["#EE6A1A18","#C25510"],["#579bfc22","#2264AD"],["#1D9E7522","#0A7A4A"],["#a25ddc22","#6B36A0"],["#EBA13A22","#8A5A12"]];
function tagsResp(a){ const lista = (a.responsaveis&&a.responsaveis.length)?a.responsaveis:(a.responsavelNome?[a.responsavelNome]:(a.nomeUsuario?[a.nomeUsuario]:[])); return lista; }
function TabelaCronograma({ lista, onEditar, onExcluir, onSalvarCampo }) {
  const [editCel, setEditCel] = useState(null);
  const [sortCampo, setSortCampo] = useState("dataInicio");
  const [sortDir, setSortDir] = useState("asc");
  const ordenarPor = (campo) => { if(sortCampo===campo){ setSortDir(d=>d==="asc"?"desc":"asc"); } else { setSortCampo(campo); setSortDir("asc"); } };
  const chaveData = (a,campo) => { const d = campo==="dataInicio" ? a.dataInicio : (a.prazo||a.dataConclusao); const p=ymd(d); return p ? p.a*10000+p.me*100+p.di : (sortDir==="asc"?99999999:0); };
  const [valEdit, setValEdit] = useState("");
  const abrirEdicao = (id, campo, valorAtual) => { setEditCel(id+":"+campo); setValEdit(valorAtual||""); };
  const salvarCel = (id, campo, valorOriginal) => { const v=valEdit.trim(); setEditCel(null); if(v!==(valorOriginal||"")) onSalvarCampo(id, campo, v); };
  const inpInline = { width:"100%", padding:"4px 6px", border:"1px solid #EE6A1A", borderRadius:5, background:"var(--input-bg)", color:"var(--text-primary)", fontSize:12.5, fontFamily:"'Inter',sans-serif", outline:"none" };
  const th = { padding:"11px 14px", fontSize:10, fontWeight:600, color:"var(--text-muted)", textTransform:"uppercase", letterSpacing:".05em", textAlign:"left", whiteSpace:"nowrap" };
  const td = { padding:"11px 14px", fontSize:12.5, color:"var(--text-secondary)", borderTop:"1px solid var(--border-color)", whiteSpace:"nowrap" };
  const fmtBR = (d)=> fmtBRcru(d);
  return (
    <div style={{ border:"1px solid var(--border-color)", borderRadius:12, overflow:"hidden", overflowX:"auto" }}>
      <table style={{ width:"100%", borderCollapse:"collapse", minWidth:760 }}>
        <thead><tr style={{ background:"var(--input-bg)" }}>
          <th style={{...th, width:40, textAlign:"center"}}>#</th><th style={th}>Assunto</th><th style={th}>Tipo</th><th style={th}>Status</th><th style={th}>Prioridade</th><th style={th}>Responsável</th><th style={{...th, cursor:"pointer", userSelect:"none"}} onClick={()=>ordenarPor("dataInicio")}>Início {sortCampo==="dataInicio"?(sortDir==="asc"?"↑":"↓"):""}</th><th style={{...th, cursor:"pointer", userSelect:"none"}} onClick={()=>ordenarPor("prazo")}>Conclusão {sortCampo==="prazo"?(sortDir==="asc"?"↑":"↓"):""}</th><th style={{...th, width:140}}>Progresso</th><th style={th}>Duração</th><th style={{...th, textAlign:"center"}}>Ações</th>
        </tr></thead>
        <tbody>
          {lista.length===0 && <tr><td style={{...td, textAlign:"center", color:"var(--text-muted)"}} colSpan={11}>Nenhuma atividade.</td></tr>}
          {(sortCampo ? [...lista].sort((x,y)=>{ const dx=chaveData(x,sortCampo), dy=chaveData(y,sortCampo); return sortDir==="asc" ? dx-dy : dy-dx; }) : lista).map((a,i)=>{
            const st = STATUS[a.status]||STATUS.pendente;
            const tp = TIPOS.find(x=>x.id===a.tipo);
            const ehMarco = a.tipo==="marco";
            return (
              <tr key={a._id} onClick={()=>onEditar(a)} style={{ cursor:"pointer" }}
                onMouseEnter={e=>e.currentTarget.style.background="var(--hover-bg)"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                <td style={{...td, textAlign:"center", color:"var(--text-muted)", fontWeight:600}}>{i+1}</td>
                <td style={{...td, color:"var(--text-primary)", fontWeight:500, whiteSpace:"normal", maxWidth:280}} onClick={e=>e.stopPropagation()}>
                  {editCel===a._id+":titulo" ? (
                    <input autoFocus value={valEdit} onChange={e=>setValEdit(e.target.value)}
                      onBlur={()=>salvarCel(a._id,"titulo",a.titulo)}
                      onKeyDown={e=>{ if(e.key==="Enter") salvarCel(a._id,"titulo",a.titulo); if(e.key==="Escape") setEditCel(null); }}
                      style={inpInline}/>
                  ) : (
                    <span onClick={()=>abrirEdicao(a._id,"titulo",a.titulo)} title="Clique para editar" style={{ cursor:"text" }}>{a.titulo}</span>
                  )}
                </td>
                <td style={td}><span style={{ color:ehMarco?"#639922":"#185FA5", fontWeight:600, fontSize:11, textTransform:"uppercase" }}>{tp?.label||"Tarefa"}</span></td>
                <td style={td} onClick={e=>e.stopPropagation()}>
                  {editCel===a._id+":status" ? (
                    <select autoFocus value={a.status||"pendente"}
                      onChange={e=>{ const v=e.target.value; setEditCel(null); onSalvarCampo(a._id,"__status__",v); }}
                      onBlur={()=>setEditCel(null)}
                      style={{ ...inpInline, appearance:"auto", padding:"3px 6px" }}>
                      {Object.entries(STATUS).map(([id,sx])=><option key={id} value={id}>{sx.label}</option>)}
                    </select>
                  ) : (
                    <span onClick={()=>abrirEdicao(a._id,"status",a.status)} title="Clique para mudar" style={{ background:st.cor+"1f", color:st.cor, padding:"2px 9px", borderRadius:99, fontSize:10.5, fontWeight:600, cursor:"pointer", whiteSpace:"nowrap" }}>{st.label}</span>
                  )}
                </td>
                <td style={td} onClick={e=>e.stopPropagation()}>
                  {editCel===a._id+":prioridade" ? (
                    <select autoFocus value={a.prioridade||"media"}
                      onChange={e=>{ const v=e.target.value; setEditCel(null); onSalvarCampo(a._id,"prioridade",v); }}
                      onBlur={()=>setEditCel(null)}
                      style={{ ...inpInline, appearance:"auto", padding:"3px 6px" }}>
                      <option value="alta">Alta</option><option value="media">Média</option><option value="baixa">Baixa</option>
                    </select>
                  ) : (() => { const pb = PRIO_BADGE[a.prioridade]||PRIO_BADGE.media; return (
                    <span onClick={()=>abrirEdicao(a._id,"prioridade",a.prioridade)} title="Clique para mudar" style={{ background:pb.cor+"1f", color:pb.cor, padding:"2px 9px", borderRadius:99, fontSize:10.5, fontWeight:600, cursor:"pointer", whiteSpace:"nowrap" }}>{pb.label}</span>
                  ); })()}
                </td>
                <td style={td}>
                  {tagsResp(a).length===0 ? <span style={{ color:"var(--text-muted)" }}>—</span> : (
                    <span style={{ display:"inline-flex", gap:4, flexWrap:"wrap" }}>
                      {tagsResp(a).map((nome,i)=>{ const c=CORES_RESP[i%CORES_RESP.length]; return <span key={i} style={{ background:c[0], color:c[1], borderRadius:99, padding:"1px 8px", fontSize:10.5, whiteSpace:"nowrap" }}>{nome}</span>; })}
                    </span>
                  )}
                </td>
                <td style={td} onClick={e=>e.stopPropagation()}>
                  {editCel===a._id+":dataInicio" ? (
                    <input type="date" autoFocus defaultValue={toInput(a.dataInicio)}
                      onChange={e=>{ const v=e.target.value; setEditCel(null); onSalvarCampo(a._id,"dataInicio",v||null); }}
                      onBlur={()=>setEditCel(null)}
                      style={{ ...inpInline, padding:"3px 6px" }}/>
                  ) : (
                    <span onClick={()=>abrirEdicao(a._id,"dataInicio","")} title="Clique para editar" style={{ cursor:"pointer" }}>{fmtBR(a.dataInicio)}</span>
                  )}
                </td>
                <td style={td} onClick={e=>e.stopPropagation()}>
                  {editCel===a._id+":prazo" ? (
                    <input type="date" autoFocus defaultValue={toInput(a.prazo||a.dataConclusao)}
                      onChange={e=>{ const v=e.target.value; setEditCel(null); onSalvarCampo(a._id,"prazo",v||null); }}
                      onBlur={()=>setEditCel(null)}
                      style={{ ...inpInline, padding:"3px 6px" }}/>
                  ) : (
                    <span onClick={()=>abrirEdicao(a._id,"prazo","")} title="Clique para editar" style={{ cursor:"pointer" }}>{fmtBR(a.prazo||a.dataConclusao)}</span>
                  )}
                </td>
                <td style={td}>
                  {(() => {
                    const pt = progressoTempo(a.dataInicio, a.prazo||a.dataConclusao);
                    if (pt===null) return <span style={{ color:"var(--text-muted)", fontSize:12 }}>—</span>;
                    const corBarra = pt>=100 ? "#1D9E75" : pt>=60 ? "#EBA13A" : "#579bfc";
                    return (
                      <span style={{ display:"inline-flex", alignItems:"center", gap:6 }} title="Tempo decorrido do prazo">
                        <span style={{ width:60, height:6, background:"var(--input-bg)", borderRadius:99, overflow:"hidden" }}>
                          <span style={{ display:"block", height:"100%", width:`${pt}%`, background:corBarra }}/>
                        </span>
                        <span style={{ fontSize:11, color:"var(--text-muted)" }}>{pt}%</span>
                      </span>
                    );
                  })()}
                </td>
                <td style={td}>{calcDuracao(a.dataInicio, a.prazo||a.dataConclusao)}</td>
                <td style={{...td, textAlign:"center", whiteSpace:"nowrap"}} onClick={e=>e.stopPropagation()}>
                  <button onClick={()=>onEditar(a)} style={{ border:"1px solid var(--border-color)", borderRadius:6, padding:"3px 10px", fontSize:11, color:"var(--text-secondary)", background:"transparent", cursor:"pointer", marginRight:6 }}>Editar</button>
                  <button onClick={()=>{ if(window.confirm("Excluir esta atividade?")) onExcluir(a); }} style={{ border:"1px solid #E24B4A44", borderRadius:6, padding:"3px 10px", fontSize:11, color:"#E24B4A", background:"transparent", cursor:"pointer" }}>Excluir</button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function ModalAtividade({ dados, users, currentUser, onClose, onSalvar, onAtualizar }) {
  const [novoComent, setNovoComent] = useState("");
  const enviarComentario = async () => {
    const t = novoComent.trim(); if(!t || !f._id) return;
    try {
      const { data } = await api.post(`/atividades/${f._id}/comentario`, { texto:t });
      setF(prev=>({...prev, comentarios:data.comentarios}));
      setNovoComent("");
      if(onAtualizar) onAtualizar(data);
    } catch(e){ console.error(e); }
  };
  const fmtDataHora = (d)=>{ if(!d) return ""; const dt=new Date(d); return dt.toLocaleDateString("pt-BR")+" "+dt.toLocaleTimeString("pt-BR",{hour:"2-digit",minute:"2-digit"}); };
  const [f, setF] = useState(dados);
  const set = (k,v)=>setF(p=>({...p,[k]:v}));
  const inp = { width:"100%", padding:"9px 11px", borderRadius:8, border:"1px solid var(--border-color)", background:"var(--input-bg)", color:"var(--text-primary)", fontSize:13, fontFamily:"'Inter',sans-serif", outline:"none" };
  const lbl = { fontSize:11, fontWeight:600, color:"var(--text-secondary)", marginBottom:5, display:"block", textTransform:"uppercase", letterSpacing:".04em" };
  return (
    <div onClick={onClose} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,.4)", zIndex:1000, display:"flex", alignItems:"flex-start", justifyContent:"center", padding:"40px 16px", overflowY:"auto" }}>
      <div onClick={e=>e.stopPropagation()} style={{ background:"var(--card-bg)", borderRadius:14, padding:24, width:"100%", maxWidth:520, boxShadow:"0 20px 60px rgba(0,0,0,.25)" }}>
        <div style={{ fontSize:16, fontWeight:700, color:"var(--text-primary)", marginBottom:18 }}>{f._id?"Editar atividade":"Nova atividade"}</div>
        <div style={{ marginBottom:14 }}>
          <label style={lbl}>Assunto / título</label>
          <input autoFocus value={f.titulo||""} onChange={e=>set("titulo",e.target.value)} placeholder="Ex: Ligar para o cliente" style={inp}/>
        </div>
        <div style={{ display:"flex", gap:10, marginBottom:14 }}>
          <div style={{ flex:1 }}><label style={lbl}>Tipo</label>
            <select value={f.tipo} onChange={e=>set("tipo",e.target.value)} style={{...inp, appearance:"auto"}}>{TIPOS.map(t=><option key={t.id} value={t.id}>{t.label}</option>)}</select></div>
          <div style={{ flex:1 }}><label style={lbl}>Prioridade</label>
            <select value={f.prioridade} onChange={e=>set("prioridade",e.target.value)} style={{...inp, appearance:"auto"}}><option value="alta">Alta</option><option value="media">Média</option><option value="baixa">Baixa</option></select></div>
          <div style={{ flex:1 }}><label style={lbl}>Status</label>
            <select value={f.status} onChange={e=>set("status",e.target.value)} style={{...inp, appearance:"auto"}}>{Object.entries(STATUS).map(([id,s])=><option key={id} value={id}>{s.label}</option>)}</select></div>
        </div>
        <div style={{ marginBottom:14 }}>
          <label style={lbl}>Responsáveis</label>
          <div style={{ display:"flex", flexWrap:"wrap", gap:6, marginBottom:(f.responsaveis&&f.responsaveis.length)?8:0 }}>
            {(f.responsaveis||[]).map((nome,idx)=>(
              <span key={idx} style={{ display:"inline-flex", alignItems:"center", gap:5, background:"#EE6A1A18", color:"#C25510", border:"1px solid #EE6A1A40", padding:"3px 8px 3px 10px", borderRadius:99, fontSize:12 }}>
                {nome}
                <span onClick={()=>set("responsaveis",(f.responsaveis||[]).filter((_,i)=>i!==idx))} style={{ cursor:"pointer", opacity:.6, fontSize:14 }}>×</span>
              </span>
            ))}
          </div>
          <input list="lista-users" placeholder="Digite ou escolha um nome e pressione Enter"
            onKeyDown={e=>{ if(e.key==="Enter"){ e.preventDefault(); const v=e.target.value.trim(); if(v&&!(f.responsaveis||[]).includes(v)){ set("responsaveis",[...(f.responsaveis||[]),v]); } e.target.value=""; } }}
            style={inp}/>
          <datalist id="lista-users">{users.map(u=><option key={u._id} value={u.nome}/>)}</datalist>
        </div>
        <div style={{ display:"flex", gap:10, marginBottom:14 }}>
          <div style={{ flex:1 }}><label style={lbl}>Data início</label><input type="date" value={f.dataInicio||""} onChange={e=>set("dataInicio",e.target.value)} style={inp}/></div>
          <div style={{ flex:1 }}><label style={lbl}>Prazo / conclusão</label><input type="date" value={f.prazo||""} onChange={e=>set("prazo",e.target.value)} style={inp}/></div>
        </div>
        <div style={{ marginBottom:22 }}>
          <label style={lbl}>Progresso · {f.progresso||0}%</label>
          <input type="range" min="0" max="100" step="5" value={f.progresso||0} onChange={e=>set("progresso",e.target.value)} style={{ width:"100%" }}/>
        </div>
        <div style={{ marginBottom:22 }}>
          <label style={lbl}>Observações</label>
          {(f.comentarios||[]).length>0 && (
            <div style={{ maxHeight:180, overflowY:"auto", marginBottom:10, display:"flex", flexDirection:"column", gap:8 }}>
              {(f.comentarios||[]).map((c,i)=>(
                <div key={i} style={{ background:"var(--input-bg)", border:"1px solid var(--border-color)", borderRadius:8, padding:"8px 11px" }}>
                  <div style={{ fontSize:13, color:"var(--text-primary)", whiteSpace:"pre-wrap", lineHeight:1.5 }}>{c.texto}</div>
                  <div style={{ fontSize:10.5, color:"var(--text-muted)", marginTop:5 }}>{c.autor||"—"} · {fmtDataHora(c.data)}</div>
                </div>
              ))}
            </div>
          )}
          {f._id ? (
            <div style={{ display:"flex", gap:8, alignItems:"flex-end" }}>
              <textarea value={novoComent} onChange={e=>setNovoComent(e.target.value)} rows={2} placeholder="Escreva um comentário..."
                onKeyDown={e=>{ if(e.key==="Enter" && (e.metaKey||e.ctrlKey)) enviarComentario(); }}
                style={{ ...inp, resize:"vertical", minHeight:44, fontFamily:"'Inter',sans-serif", lineHeight:1.5, flex:1 }}/>
              <button onClick={enviarComentario} style={{ background:"#EE6A1A", border:"none", borderRadius:8, padding:"10px 16px", color:"#fff", fontWeight:600, fontSize:13, cursor:"pointer", whiteSpace:"nowrap" }}>Comentar</button>
            </div>
          ) : (
            <div style={{ fontSize:12, color:"var(--text-muted)", fontStyle:"italic", padding:"8px 0" }}>Salve a atividade primeiro para adicionar comentários.</div>
          )}
        </div>
        <div style={{ display:"flex", gap:10, justifyContent:"flex-end" }}>
          <button onClick={onClose} style={{ background:"transparent", border:"1px solid var(--border-color)", borderRadius:8, padding:"9px 18px", color:"var(--text-secondary)", fontWeight:600, fontSize:13, cursor:"pointer" }}>Cancelar</button>
          <button onClick={()=>f.titulo?.trim() && onSalvar(f)} style={{ background:"#EE6A1A", border:"none", borderRadius:8, padding:"9px 22px", color:"#fff", fontWeight:700, fontSize:13, cursor:"pointer" }}>Salvar</button>
        </div>
      </div>
    </div>
  );
}
